exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n", ""]);

// exports
exports.locals = {
	"primaryColor": "#68689e",
	"primaryColorVxFiber": "#7339dd",
	"pinkishGrey": "#989898",
	"whiteGrey": "#dedede",
	"white": "#fafafa",
	"secondaryColor": "#47475d",
	"secondaryColorLighten": "#56566e"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/assets/css/colors.css
// module id = 1
// module chunks = 9